"use strict";
/**
	normalizza un numero: 23.234 diventa 0.23234 
 */
var rNorm = function(a) {
	let b = 0;
	(a > 1.0) ? b = a / Math.pow(10, (Math.log(a) * Math.LOG10E | 0)) : b = a / Math.pow(10, (Math.log(a) * Math.LOG10E | 0));
	return b;
}


window.rTiming = window.parent.rTiming;

/**
 * Si fa carico di tutti gli eventi
 * tutti i parametri in uscita sono da 0->1!!! 
 */


var rControl = {
	element: {}, //il dom element su cui faremo funzionare 
	mouse: { //mouse events
		origin: [0.0], //origine del punto
		position: [0.0], //origine del punto
		isDrawing: false,
		mx: 0.5, //solo quando mouse down
		my: 0.5, //solo quando mouse down
		mz: 0.5, //vicinanza z al target (da -1 a +1)
		mc: [0, 0, 0],  //posizione x,y,z aggiustata in base al centro (da -1 a +1); 
		x: 0.5, //mouseposition
		y: 0.5,  //mouseposition
		csar: [0, 0, 0, 0], //cos, sin, angle, Radius (angle in radians of course)
		mp: [0, 0, 0, 0], //mouse position aggiustata in modo che il centro sia 0,0 mx,mx,diag,element diag
		dist: 0, //magnitude (distance from center)
		alpha: 0, //the angle
		magn: 0,
		rotx: 0,
		roty: 0,
		rot: 0, //direzione della rotazione z , oraria (+1) o antioraria (-1) o fermo: (0)
		dif: 0, //ingrandimento : +1, -1, 0 ()
		dxy: [0, 0] //direzione del movimento quando mouse down:[x,y], indica entità del movimento, 
		//negativo quando a destra, positivo verso sinistra

	},
	glob: {
		PI: 3.141592654, //  PI
		PI_2: 1.570796327, // 1/2 PI
		PI_10: 0.3141592654, // 10/PI
		PI_100: 0.03141592654, // 100/PI
		PI2: 6.283185307, // 1/2 PI
		PI3: 9.424777961, // 3*PI
		PI4: 12.566370614 // 4*PI
	},
	//pointer events
	pointer: {
		evCache: [],
		prevDiff: -1, //distanza fra i punti
		prevSlope: 0, //slope della linea che unisce i punti

	},
	//il feedback sopra
	txt: {
		d: [],
	},
	/*##############################################################*/
	/*##############################################################*/
	init: function(elem) {
		this.element = elem;
		this.mouseInit();
		this.keyInit();

		this.pointerInit();
		this.initText();
	},
	/*##############################################################*/
	/*##############################################################*/
	pointerInit() {
		let rapp = this;
		let mm = rapp.mouse;
		let pp = rapp.pointer;

		let prevDiff = pp.prevDiff;
		let prevSlope = pp.prevSlope;
		let evCache = pp.evCache;


		let log = console.log;

		// Install event handlers for the pointer target
		var el = this.element; //l'elelemnto su cui prendiamo gli eventi

		el.onpointerdown = pointerdown_handler;
		el.onpointermove = pointermove_handler;

		// Use same handler for pointer{up,cancel,out,leave} events since
		// the semantics for these events - in this app - are the same.
		el.onpointerup = pointerup_handler;
		el.onpointercancel = pointerup_handler;
		el.onpointerout = pointerup_handler;
		el.onpointerleave = pointerup_handler;

		function pointerdown_handler(ev) {
			ev.preventDefault();
			// The pointerdown event signals the start of a touch interaction.
			// This event is cached to support 2-finger gestures
			evCache.push(ev);

			mm.isDrawing = true;
			mm.origin = [ev.x, ev.y];

			mm.rot = 0; //non c'è rotazione
			mm.dif = 0; //non c'è ingrandimento

			//			log("pointerDown", evCache, evCache.length, ev);
		};

		function pointermove_handler(ev) {

			ev.preventDefault();
			//			ev.target.style.border = "3px solid green";

			// This function implements a 2-pointer horizontal pinch/zoom gesture.
			//
			// If the distance between the two pointers has increased (zoom in),
			// the target element's background is changed to "pink" and if the
			// distance is decreasing (zoom out), the color is changed to "lightblue".
			//
			// This function sets the target element's border to "dashed" to visually
			// indicate the pointer's target received a move event.
			//			log("pointerMove", ev);
			//			ev.target.style.border = "dashed";

			// Find this event in the cache and update its record with this event
			for (var i = 0; i < evCache.length; i++) {
				if (ev.pointerId == evCache[i].pointerId) {
					evCache[i] = ev;
					break;
				}
			}

			// If two pointers are down, check for pinch gestures
			if (evCache.length == 2) {
				// Calculate the distance between the two pointers
				var curDiff = Math.abs(evCache[0].clientX - evCache[1].clientX);

				//calculates the slope of the line between the pointers
				var curSlope = (evCache[1].clientY - evCache[0].clientY) / (evCache[1].clientX - evCache[0].clientX);

				//Rotazione oraria o antioraria in base alla rotazione della linea che unisce i punti!
				if (curSlope > pp.prevSlope) {
					//					log('rotate', mm.rot);
					mm.rot -= .01;
				}
				if (curSlope < pp.prevSlope) {
					//					log('rotate', mm.rot);
					mm.rot += .01;
				}


				if (pp.prevDiff > 0) {
					let md = ((1 - Math.abs(mm.magn)) * .1);
					if (curDiff > pp.prevDiff) {
						// The distance between the two pointers has increased
						//						log("Pinch moving OUT -> Zoom in", evCache.length, ev);

						mm.magn += md;

					}
					if (curDiff < pp.prevDiff) {
						// The distance between the two pointers has decreased
						//						log("Pinch moving IN -> Zoom out", evCache.length, ev);
						mm.magn -= md;

					}
				}

				//				rapp.t0('pt rot: ' + mm.rot + ' magn: ' + mm.magn);
				// Cache the distance for the next move event
				pp.prevDiff = curDiff;
				pp.prevSlope = curSlope;
			} else {
				//un solo touch: come fosse mouse mover
				rapp.mover(ev);
			}
			//			rapp.t2('base rot: ' + mm.rot + ' magn: ' + mm.magn + ' | ' + Math.random().toFixed(3));

		};


		function pointerup_handler(ev) {

			ev.preventDefault();

			mm.isDrawing = false;

			mm.rot = 0; //non c'è rotazione
			mm.dif = 0; //non c'è ingrandimento

			// Remove this pointer from the cache and reset the target's
			// background and border
			remove_event(ev);
			//			ev.target.style.background = "white";
			//			ev.target.style.border = "3px solid red";

			//movimento relativo x,y azzerato
			mm.dxy = [0, 0]; //azzeriamo il movimento


			// If the number of pointers down is less than two then reset diff tracker
			if (evCache.length < 2) {
				prevDiff = -1;
			}
			//			log('out', evCache, evCache.length, ev.type, ev);

		};


		function remove_event(ev) {
			// Remove this event from the target's cache
			for (var i = 0; i < evCache.length; i++) {
				if (evCache[i].pointerId == ev.pointerId) {
					evCache.splice(i, 1);
					break;
				}
			}
		}

	},
	/*##############################################################*/
	/*##############################################################*/
	//inizializza le robe
	mouseInit: function() {
		const el = this.element;
		let mm = this.mouse;
		let rapp = this;

		//diagonale canvas considerando il centro 0,0


		el.addEventListener('mousedown', e => {
			mm.isDrawing = true;
			mm.origin = [e.x, e.y];
		});
		el.addEventListener('mousemove', e => {
			this.mover(e);
			//se mousedown movimimento nella direzione con entità del movimento!
			if (mm.isDrawing) mm.dxy = [mm.origin[0] - e.x, mm.origin[1] - e.y];
		});
		window.addEventListener('mouseup', e => {
			if (mm.isDrawing === true) {
				mm.isDrawing = false;
				mm.dxy = [0, 0]; //azzeriamo il movimento
			}
		});
		el.onwheel = function(event) { //wheel da 0 a 1!!!
			event.preventDefault();
			if (mm.mz >= 0 && mm.mz <= 1) {
				mm.mz += event.deltaY * 0.001;
				if (mm.mz > 1) mm.mz = 1;
				if (mm.mz < 0) mm.mz = 0;
				mm.mc[2] = mm.mz * 2 - 1;
			}
			//magnifying factor in base al mouse wheel

			let md = ((1 - Math.abs(mm.magn)) * .1);

			(event.deltaY > 0) ? mm.magn += md : mm.magn -= md;

			//			(mm.dist > 0) ? mm.magn=Math.log(mm.dist+1) : mm.magn=-Math.log(mm.dist+1);  


			//			if (mm.magn > 1) mm.magn = 1;
			//			if (mm.magn < 1) mm.magn = -1;

			//			console.log("dva", md, mm.magn, event.deltaY);

			//			rapp.t1('mouse magn: ' + mm.magn.toFixed(2));

		}
	},

	//movimento dell'elemento 
	mover: function(e) {
		const el = this.element;
		let fac = 35; //move factor
		let mm = this.mouse;
		let dir = [];
		let mpt = mm.mp; //diagonale e mezza diagonale

		mm.position = [e.x, e.y];

		mpt[3] = Math.sqrt(Math.pow(el.width / 2, 2) + Math.pow(el.height / 2, 2));

		//aggiustiamo la posizione del mause in modo da mettere il centro a 0,0
		mpt[0] = (e.x - el.width / 2);
		mpt[1] = (e.y - el.height / 2);

		//raggio
		mpt[2] = Math.sqrt(Math.pow(mpt[0], 2) + Math.pow(mpt[1], 2));

		//calcolo cos e sin (prima x, poi y)!!
		//		(mpt[2]) ? pos2 = [mpt[0] / mpt[2], mpt[1] / mpt[2]] : pos2 = [0, 0];


		if (mm.isDrawing === true) {

			mm.csar[0] = mpt[0] / mpt[2]; //cosinus			
			mm.csar[1] = mpt[1] / mpt[2]; //sinus

			//spostamento rispetto all'origine
			let dx = (mm.position[0] - mm.origin[0]) / el.width;
			let dy = (mm.position[1] - mm.origin[1]) / el.height;

			mm.rotx += dx * this.glob.PI_100; //rotazione x
			mm.roty += dy * this.glob.PI_100; //rotazione y

			//				if (mm.rotx > this.glob.PI) mm.rotx -= this.glob.PI;
			//				if (mm.rotx < 0) mm.rotx += this.glob.PI2;
			//				if (mm.roty > this.glob.PI) mm.roty -= this.glob.PI;
			//				if (mm.roty < 0) mm.roty += this.glob.PI2;

			mm.csar[2] = Math.atan2(mm.csar[0], mm.csar[1]); //angolo in radianti
			mm.csar[3] = mpt[2] / mpt[3]; //radius

			//direzione del movimento
			dir = [
				mm.csar[0] * mm.csar[3], //direzione x- coseno*radius
				mm.csar[1] * mm.csar[3] //direzione y- seno*radius
			];


			if (mm.x <= 1 && mm.x >= 0) {
				mm.x += (dir[0] * fac);  //non rileva la posizione ma ci si muove verso la direzione!
			}
			if (mm.y <= 1 && mm.y >= 0) {
				mm.y += (dir[1] * fac);
			}

			if (mm.mx <= 1 && mm.mx >= 0) {
				mm.mx += (dir[0] * fac);
			}
			if (mm.my <= 1 && mm.my >= 0) {
				mm.my += (dir[1] * fac);
			}
			if (mm.mx > 1) mm.mx = 1;
			if (mm.mx < 0) mm.mx = 0;
			if (mm.my > 1) mm.my = 1;
			if (mm.my < 0) mm.my = 0;

			//MOVIMENTO RELATIVO MOUSE
			//se mousedown movimimento nella direzione con entità del movimento!
			mm.dxy = [mm.origin[0] - e.x, mm.origin[1] - e.y];

		}
	},

	/*##############################################################*/
	/*##############################################################*/
	keyInit: function() {
		let app = this;
		//Key listener!
		document.addEventListener('keydown', e => {
			if (e.code == "KeyF") {
				app.fullScreenOn();
			} else if (e.code == "KeyN") {
				app.fullScreenOff();
			}
		});
	},
	/*##############################################################*/
	/*##############################################################*/
	fullScreenOn: function() {/* View in fullscreen */
		let elem = this.element;

		if (elem.requestFullscreen) {
			elem.requestFullscreen();
		} else if (elem.webkitRequestFullscreen) { /* Safari */
			elem.webkitRequestFullscreen();
		} else if (elem.msRequestFullscreen) { /* IE11 */
			elem.msRequestFullscreen();
		}
	},
	/*##############################################################*/
	/*##############################################################*/
	fullScreenOff: function() {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) { /* Safari */
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) { /* IE11 */
			document.msExitFullscreen();
		}
	},
	/*##############################################################*/
	/*##############################################################*/
	//prepara un div sopra l'elemento
	initText: function() {
		let app = this;
		for (let i = 0; i < 4; i++) {
			app.txt.d[i] = document.getElementById("ct" + i);
		}
	},
	t0: function(a = "") { this.txt.d[0].innerHTML = a; },
	t1: function(a = "") { this.txt.d[1].innerHTML = a; },
	t2: function(a = "") { this.txt.d[2].innerHTML = a; },
	t3: function(a = "") { this.txt.d[3].innerHTML = a; },

	/*##############################################################*/
	/*##############################################################*/
}

/**scrive nella finestra l'avvertimento
elem: l'elemento il cui innerHtml sarà sovrascritto
h: il heading
p: il testo
*/
var writeNotice = function(elem, h, p) {
	console.log('writenotice');
	/**Il div che contiene il content */
	elem.innerHTML = `<h2>${h}</h2>`;
	elem.innerHTML += `<p>${p}</>`;
}

export {
	rControl,
	rNorm,
	writeNotice
};